export const createAuthInterceptor = (api) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.clear()
        sessionStorage.clear()

        window.location.href = '/login'
      }

      return Promise.reject(error)
    },
  )
}
